
import { PropTypes } from 'prop-types';
const TravelCard = ({ icon, title, children }) => {
    return (
        <div className="px-4 md:px-8 py-7 bg-white flex-1 rounded-lg shadow-lg flex-col justify-start items-start gap-2 flex">
            <div className="flex flex-col">

                {icon}
                <span className="text-slate-800 text-2xl font-bold  leading-7 tracking-tight">{title}</span>
                {
                    children
                }

            </div>
        </div>
    )
}
TravelCard.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string,
    children: PropTypes.node
}
export default TravelCard